<template>
    <component  
        :is="!isExternal && href ? 'router-link-component' : 'html-link-component'" 
        :href="href"
        :target="target"
        :active-class="activeClass"
        :exact-active-class="exactActiveClass">
        <slot></slot>
    </component>
</template>
<script>
import RouterLinkComponent from '#app#/components/common/LinkElements/RouterLink.vue'
import HtmlLinkComponent from '#app#/components/common/LinkElements/HtmlLink.vue'

export default {
    props: {
        link: {
            type: String,
            required: true
        },
        newWindow: {
            type: Boolean,
            default: false
        },
        activeClass: {
            type: String,
            default: null
        },
        exactActiveClass: {
            type: String,
            default: null
        }
    },

    components: {
        RouterLinkComponent,
        HtmlLinkComponent,
    },

    computed: {
        domain() {
            return window.location.protocol + '//' + window.location.hostname
        },

        isExternal() {
            if (this.link.indexOf('/media/') !== -1) {
                // Media download link
                return true
            } else if (this.link.indexOf(this.domain) !== -1) {
                // Internal absolute
                return false
            } else if(this.link.indexOf('http') === -1) {
                // Internal relative
                return false
            } else {
                // External
                return true
            }
        },

        href() {
            let href = ''

            if (this.link.indexOf(this.domain) !== -1) {
                // Internal absolute
                href = this.link.replace(this.domain, '');
            } else {
                href = this.link;
            }

            if(href == '//' || href.length == 0) {
                href = '/'
            }

            return href
        },

        target() {
            return this.isExternal || this.newWindow ? '_blank' : '_self'
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/Link.vue